import React, { PureComponent } from "react";
import classnames from "classnames";

import { Progress } from "antd";
import { getUserNameForAvatar } from "Utils";
import styles from "./Item.local.scss";
import { TrelloIcon } from "../Common/Icons";
import _ from "i18n";

class Item extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAllRoles: []
    };
  }

  sumStatisticPresentation = item => {
    return (
      item &&
      item.statistic &&
      item.statistic.notPrepared &&
      item.statistic.prepared &&
      item.statistic.presented &&
      parseInt(item.statistic.notPrepared, 10) +
        parseInt(item.statistic.prepared, 10) +
        parseInt(item.statistic.presented, 10)
    );
  };

  showRoles = (item, e) => {
    this.setState({
      ...this.state,
      showAllRoles: [...this.state.showAllRoles, item.id]
    });
    e.stopPropagation();
  };
  renderFoldersRoles(statistic) {
    let { item } = this.props;
    let { showAllRoles } = this.state;

    const roles = [
      { key: "ge", value: statistic.encodingManager },
      { key: "gd", value: statistic.manager },
      { key: "es", value: statistic.encodingSupervisor },
      { key: "scan", value: statistic.scanOperator },
      { key: "super", value: statistic.supervisor }
    ];
    const rolesNotEmpty = roles.filter(
      role => role.value !== "0" && role.value !== null
    );
    return (
      <div className={styles.list_item_roles}>
        {rolesNotEmpty.length > 2 &&
        rolesNotEmpty[0].value &&
        rolesNotEmpty[0].value !== "0" &&
        showAllRoles.filter(collabId => collabId === item.id).length === 0 ? (
          <div>
            <div className={classnames(styles.role)}>
              {_(rolesNotEmpty[0].key) + " (" + rolesNotEmpty[0].value + ")"}
            </div>
            <div
              style={{
                color: "#838383",
                display: "flex",
                justifyContent: "center",
                textDecoration: "underline"
              }}
            >
              <span
                onClick={e => {
                  this.showRoles(item, e);
                }}
              >
                + {rolesNotEmpty.length - 1} roles
              </span>
            </div>
          </div>
        ) : rolesNotEmpty.length === 0 ? (
          <div style={{ height: "3rem", color: "#b7b7b7" }}>_______</div>
        ) : (
          roles.map((role, i) => {
            return role.value && role.value !== "0" ? (
              <div
                className={classnames(
                  styles.role,
                  rolesNotEmpty.length === 1 ? styles.size : ""
                )}
              >
                {_(role.key) + " (" + role.value + ")"}
              </div>
            ) : (
              ""
            );
          })
        )}
      </div>
    );
  }
  renderCollaborator() {
    let { item, synchro } = this.props;

    let avatarDiv = null;

    if (item && item.avatarUrl) {
      avatarDiv = (
        <div
          className={classnames(styles.user_avatar, "employee")}
          style={{ backgroundImage: `url(${item.avatarUrl})` }}
        />
      );
    } else if (item) {
      avatarDiv = (
        <div
          className={classnames(
            synchro == 1 ? styles.user_avatar : styles.user_avatar__empty,
            "empty-avatar",
            "employee"
          )}
        >
          <span className="empty-avatar__initials">
            {item.firstName && item.lastName
              ? getUserNameForAvatar(item.firstName, item.lastName)
              : getUserNameForAvatar(item.name, "")}
          </span>
        </div>
      );
    }
    return item ? (
      <div className={classnames(styles.collaborateurs)}>
        <div
          key={item.key}
          className={classnames(
            synchro == 1
              ? `${styles.list_item}  border-${item.colorClass} `
              : `${styles.list_item_empty}  border-${item.colorClass} `
          )}
          onClick={() => {
            this.props.handleRedirectCollaborator(item);
          }}
        >
          <div
            className={
              synchro == 1
                ? styles.list_item__name
                : styles.list_item__name___empty
            }
          >
            {item.firstName && item.lastName
              ? item.firstName + " " + item.lastName
              : item.name}
          </div>
          {synchro === 1 && this.renderFoldersRoles(item.statistic)}
          {synchro === 1 ? (
            <div className={styles.icons}>
              <div className={styles.icons_statistic}>
                <TrelloIcon
                  fill={
                    this.sumStatisticPresentation(item) !== 0
                      ? "#F9626D"
                      : "#efafb2"
                  }
                  size={23}
                />
                <span className={styles.number}>
                  {this.sumStatisticPresentation(item) !== 0
                    ? item.statistic.notPrepared
                    : "_"}
                </span>
              </div>
              <div
                style={{
                  borderLeft: "solid",
                  borderWidth: "thin",
                  borderColor: "lightgray"
                }}
                className={styles.icons_statistic}
              >
                <TrelloIcon
                  fill={
                    this.sumStatisticPresentation(item) !== 0
                      ? "#02af8e"
                      : "#9de9dc"
                  }
                  size={23}
                />
                <span className={styles.number}>
                  {" "}
                  {this.sumStatisticPresentation(item) !== 0
                    ? item.statistic.prepared
                    : "_"}
                </span>
              </div>
              <div
                style={{
                  borderLeft: "solid",
                  borderWidth: "thin",
                  borderColor: "lightgray"
                }}
                className={styles.icons_statistic}
              >
                <TrelloIcon
                  fill={
                    this.sumStatisticPresentation(item) !== 0
                      ? "#6D7F92"
                      : "#b3b5ba"
                  }
                  size={23}
                />
                <span className={styles.number}>
                  {" "}
                  {this.sumStatisticPresentation(item) !== 0
                    ? item.statistic.presented
                    : "_"}
                </span>
              </div>
            </div>
          ) : (
            <div style={{ color: "#bbbbbb" }}> _______________ </div>
          )}
        </div>
        <div className={styles.collaborateur}>
          <div
            onClick={() => {
              this.props.handleRedirectCollaborator(item);
            }}
          >
            {synchro == 1 && (
              <div className={styles.user_performance}>
                <Progress
                  width={130}
                  strokeWidth={4}
                  type="circle"
                  percent={item.performance[0].percentage}
                  status={"normal"}
                  showInfo={false}
                  strokeColor={"#32445e"}
                />
                <span>
                  Perf.
                  <br /> {item.performance[0].percentage + "%"}
                </span>
              </div>
            )}
            {avatarDiv}
          </div>
        </div>
      </div>
    ) : (
      ""
    );
  }

  render() {
    return this.renderCollaborator();
  }
}

export default Item;



// WEBPACK FOOTER //
// ./src/components/Collaborator/Item.js